import axios from "axios";
import { API_URL, FOLDERPATH } from "../Constants/config";
import { toast } from "react-toastify";
import {
  PINCODE_LOADING,
  PINCODE_SUCCESS,
  PINCODE_FAILED,
} from "../Constants/pincodeConstants";
import { handleApiError } from "../Helper/actionHelper";


export const getPincode = (record, caseCheckId = "", callback = () => {}) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  
    dispatch({ type: PINCODE_LOADING });

    const requestData = {
      token: userLocalData.id,
      "pincode": record[0].value
    };

    //return false;
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    //axios.defaults.baseURL = API_URL;

    const { data } = await axios.post(FOLDERPATH + 
      "/GenericApi/getStateAndCityForPincode",
      requestData,
      {
        headers,
      }
    );
    callback({
      case_check_id : caseCheckId,
      data : data?.data || data
    })
    dispatch({
      type: PINCODE_SUCCESS,
      payload: data,
      customData: record[0]
    });
    handleApiError(data);
  } catch (error) {
    dispatch({
      type: PINCODE_FAILED,
      payload:
        error?.response && error?.response?.data?.message
          ? error?.response
          : error?.response,
    });
    handleApiError(error);
  }
};


export const deletePinCode = () => (dispatch) => {
  dispatch({
    type: PINCODE_SUCCESS,
    payload: [],
    customData: null
  });
};



